import { post } from "@axios";
import { requests } from "shared/requests";
import { AUTH_LOGOUT } from "actions/auth";
import { INITIAL_SYNC_PRODUCTS } from "actions/sync-products";
import { INITIATE_STORES } from "actions/stores";

const normalizeDtfOrdersResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.orders)) return response.orders;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

const fetchDtfOrders = (emailid, token) => {
  return async (dispatch) => {
    if (!emailid) return { error: true, message: "User not signed in" };

    try {
      const response = await post({
        url: requests.getDtfOrders,
        data: { user: emailid },
        token,
      });

      if (response?.token === "failed") {
        dispatch({ type: INITIATE_STORES });
        dispatch({ type: AUTH_LOGOUT });
        dispatch({ type: INITIAL_SYNC_PRODUCTS });
        return { error: true, message: "Session expired" };
      }

      return normalizeDtfOrdersResponse(response);
    } catch (error) {
      return { error: true, message: error.message };
    }
  };
};

const normalizeAllSubmittedDtfOrdersResponse = (response) => {
  if (response?.error) return response;

  const orders = Array.isArray(response)
    ? response
    : Array.isArray(response?.orders)
      ? response.orders
      : Array.isArray(response?.data)
        ? response.data
        : [];

  const totalCount =
    response?.orderCounts?.TotalOrders ??
    response?.totalCount ??
    response?.total ??
    orders.length;

  return { orders, totalCount };
};

const fetchAllSubmittedDtfOrders = ({ skip, take }, token) => {
  return async (dispatch) => {
    try {
      const response = await post({
        url: requests.allSubmittedDtfOrders,
        data: { skip, take },
        token: token ? `Bearer ${token}` : undefined,
      });

      if (response?.token === "failed" || response?.tokenExpired) {
        dispatch({ type: INITIATE_STORES });
        dispatch({ type: AUTH_LOGOUT });
        dispatch({ type: INITIAL_SYNC_PRODUCTS });
        return { error: true, message: "Session expired" };
      }

      return normalizeAllSubmittedDtfOrdersResponse(response);
    } catch (error) {
      return { error: true, message: error.message };
    }
  };
};

export {
  fetchDtfOrders,
  fetchAllSubmittedDtfOrders,
  normalizeDtfOrdersResponse,
  normalizeAllSubmittedDtfOrdersResponse,
};
